import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useBlocker } from "./useBlocker";
export function useCallbackPrompt(when) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPrompt, setShowPrompt] = useState(false);
  const [lastLocation, setLastLocation] = useState(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const cancelNavigation = useCallback(() => {
    setShowPrompt(false);
  }, []);
  const handleBlockedNavigation = useCallback(
    (nextLocation) => {
      console.log(nextLocation);
      if (nextLocation.location.pathname !== location.pathname) {
        console.log("block");
        let conf = window.confirm(
          "Are you sure you want to leave.  You appear to have unsaved changes"
        );
        console.log(conf);
        if (conf) {
          setConfirmedNavigation(true);
        }
        setLastLocation(nextLocation);
        return conf;
      }
      return true;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location]
  );
  const confirmNavigation = useCallback(() => {
    setShowPrompt(false);
    setConfirmedNavigation(true);
  }, []);
  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation.location.pathname);
      setConfirmedNavigation(false);
    }
  }, [confirmedNavigation, lastLocation]);
  useBlocker(handleBlockedNavigation, when);
  return [showPrompt, confirmNavigation, cancelNavigation];
}
